export class ApiSettings {

    public static API_BASE = "/api/site";
    
}
